/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AddStory from '../Common/addStory';
import Result from '../WorkPackage/result';

const DetailStoriesTab = ({
  id,
  stories,
  disabled,
  isLoading,
  createTemporaryStory,
  updateTemporaryStory,
  storeStories,
  storyOrganizationLevel,
  result,
  showDeleted
}) => (
  <div>
    <div className="story-header">
      <div className="col-sm-12 feature-add-story">
        <AddStory
          label="STORY"
          disabled={disabled}
          featureId={id}
          parentId={id}
          level={1}
          result={result}
          isLoading={isLoading}
          isNewWorkPackage={id <= 0}
          createTemporaryStory={createTemporaryStory}
          organizationLevel={storyOrganizationLevel}
          placement="result feature"
        />
      </div>
    </div>
    <div className="story-body">
      <div className="uncategorized">
        {stories.map((story) => {
          if (!story.deleted_at || (showDeleted && story.deleted_at))
            return (
              <div
                key={story.id ? story.id : story.temporaryId}
                className="feature-story"
              >
                <Result
                  result={story}
                  storeStories={storeStories}
                  updateTemporaryStory={updateTemporaryStory}
                  isNewFeature={id <= 0}
                  noHolon
                  childCard
                />
              </div>
            );
        })}
      </div>
    </div>
  </div>
);

DetailStoriesTab.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.number,
  stories: PropTypes.array,
  isLoading: PropTypes.bool,
  createTemporaryStory: PropTypes.func,
  updateTemporaryStory: PropTypes.func,
  storeStories: PropTypes.func,
  result: PropTypes.object.isRequired
};

DetailStoriesTab.defaultProps = {
  disabled: true,
  id: 0,
  stories: [],
  isLoading: false
};

const mapStateToProps = (state) => ({
  showDeleted: state.trashReducer.showTrash
});
export default connect(mapStateToProps)(DetailStoriesTab);
